<script>
import { mapGetters } from 'vuex'

import Spacer from 'linna/components/Spacer'

import Buttons from '@/components/snippets/Buttons'
import StyledButton from '@/components/snippets/StyledButton'
import FileList from '@/components/widgets/FileList'

export default {
  name: 'ViewFiles',

  components: {
    Buttons,
    FileList,
    Spacer,
    StyledButton
  },

  data () {
    return {
      filesOnScreen: 10,
      offset: 0
    }
  },

  computed: {

    ...mapGetters([
      'files'
    ]),

    visibleFiles () {
      return this.files.slice(this.offset, this.offset + this.filesOnScreen)
    },

    lastIndex () {
      return this.files.length - 1
    },

    maxOffset () {
      return this.lastIndex - this.filesOnScreen
    }

  },

  methods: {

    goToPreviousPage () {
      this.offset = Math.max(this.offset - this.filesOnScreen, 0)
    },

    goToNextPage () {
      this.offset = Math.min(this.offset + this.filesOnScreen, this.lastIndex)
    }

  }

}
</script>

<template>
  <div class="c-view-files">
    <div class="c-view-files-content">

      <div class="c-view-files-actions">

        Displaying {{ offset + 1 }}-{{ offset + filesOnScreen }} / {{ files.length }}

        <spacer />

        <buttons>

          <styled-button
            :disabled="offset <= 0"
            @click="goToPreviousPage"
          >
            PRV
          </styled-button>

          <styled-button
            :disabled="offset >= maxOffset"
            @click="goToNextPage"
          >
            NXT
          </styled-button>

        </buttons>

        <spacer />

        <buttons>

          <styled-button>
            OPEN
          </styled-button>

          <styled-button>
            DTLS
          </styled-button>

          <styled-button>
            UNLK
          </styled-button>

        </buttons>

      </div>

      <file-list :files="visibleFiles" />

    </div>
  </div>
</template>

<style lang="scss">

.c-view-files-content {
  @include keep-center;
  @include limit-content-very-loose;
}

.c-view-files-actions {
  @include flex;
  @include flex-center;
  @include push-tight-bottom;
}

</style>
